import moment from "moment";
import * as XLSX from "xlsx";

export const exportToExcel = (data, fileName = "products", businessName) => {
  if (!data || data.length === 0) {
    console.error("No data provided for export.");
    return;
  }

  // Define headers with warnings
  const headers = [
    [`${businessName}`,'','','','', `Downloaded Date - ${moment().format("Do MMM YYYY")}`],
    ["", "DO NOT EDIT PRODUCT IDs", "DO NOT EDIT PRODUCT NAMEs"],
    [
      "S.no",
      "Product Id",
      "Product Name",
      "Available Quantity",
      "Original Price",
      "Sale Price",
    ],
  ];

  // Format data rows
  const formattedData = data.map(
    (
      {
        id,
        productName,
        availableQuantity,
        productOriginalPrice,
        productSalePrice,
      },
      index
    ) => [
      index + 1,
      id,
      productName,
      availableQuantity,
      productOriginalPrice,
      productSalePrice,
    ]
  );

  // Combine headers and data
  const finalData = [...headers, ...formattedData];

  // Convert to worksheet
  const worksheet = XLSX.utils.aoa_to_sheet(finalData);

  // Create workbook and append worksheet
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Products");

  // Write workbook and create Blob
  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  const excelBlob = new Blob([excelBuffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  // Create download link
  const url = URL.createObjectURL(excelBlob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${fileName}.xlsx`;
  document.body.appendChild(a);
  a.click();

  // Cleanup
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};

export const exportToExcelCatalogPartnerData = (
  data,
  fileName = "products",
  businessName
) => {
  if (!data || data.length === 0) {
    console.error("No data provided for export.");
    return;
  }

  // Define headers with warnings
  const headers = [
    [`${businessName}`,'','','','', `Downloaded Date - ${moment().format("Do MMM YYYY")}`],
    ["", "DO NOT EDIT PRODUCT IDs", "DO NOT EDIT PRODUCT NAMEs", "DO NOT EDIT SKU Codes"],
    ["S.no", "Product Id", "Product Name", "SKU Code", "Original Price", "Sale Price"],
  ];

  // Format data rows
  const formattedData = data.map(
    ({ id, productName, productOriginalPrice, productSalePrice, skuId }, index) => [
      index + 1,
      id,
      productName,
      skuId,
      productOriginalPrice,
      productSalePrice,
    ]
  );

  // Combine headers and data
  const finalData = [...headers, ...formattedData];

  // Convert to worksheet
  const worksheet = XLSX.utils.aoa_to_sheet(finalData);

  // Create workbook and append worksheet
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Products");

  // Write workbook and create Blob
  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  const excelBlob = new Blob([excelBuffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  // Create download link
  const url = URL.createObjectURL(excelBlob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${fileName}.xlsx`;
  document.body.appendChild(a);
  a.click();

  // Cleanup
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};

export const validateInventoryData = (
  productDetails,
  mainProducts = [],
  isValidateAll,
  isCatalogPartner
) => {
  let allProducts = [...productDetails];

  let isError = false;
  let errorCount = 0

  productDetails.forEach((product, index) => {
    if (!isValidateAll && !product.isSelected) {
      allProducts[index] = {
        ...allProducts[index],
        errors: null,
      };
      return;
    }

    let errors = null;

    const isProductIdValid = mainProducts?.find(
      (item) => item?.id === product?.productId
    );

    if (!isProductIdValid) {
      errors = {
        ...errors,
        productId:
          "Invalid product ID. Delete the row and upload the data with the correct product ID.",
      };
    } else {
      delete errors?.productId;
    }

    if (!product?.productOriginalPrice || product?.productOriginalPrice == 0) {
      errors = {
        ...errors,
        productOriginalPrice: "Enter original price",
      };
    } else {
      delete errors?.productOriginalPrice;
    }

    if (!product?.productSalePrice || product?.productSalePrice == 0) {
      errors = {
        ...errors,
        productSalePrice: "Enter sale price",
      };
    } else {
      delete errors?.productSalePrice;
    }

    if (product?.productSalePrice && product?.productOriginalPrice) {
      if (
        Number(product?.productSalePrice) >
        Number(product?.productOriginalPrice)
      ) {
        errors = {
          ...errors,
          productSalePrice:
            "Offer Price must be less than or equal to Original Price",
        };
      }
    }

    if (!isCatalogPartner) {
      if (!product?.availableQuantity || product?.availableQuantity == 0) {
        errors = {
          ...errors,
          availableQuantity: "Enter available qty",
        };
      } else {
        delete errors?.availableQuantity;
      }

      if (Number(product?.availableQuantity) > 0) {
        if (
          Number(product?.availableQuantity) <=
          Number(product?.originalProdInfo?.maxOrderQuantity)
        ) {
          errors = {
            ...errors,
            availableQuantity:
              "Available quantity should be greater than Max quantity per order.",
          };
          isError = true;
        }

        if (
          Number(product?.availableQuantity) <=
          Number(product?.originalProdInfo?.alertQuantity)
        ) {
          errors = {
            ...errors,
            availableQuantity:
              "Available quantity should be more than Alert Quantity.",
          };
          isError = true;
        }
      }
    }

    if (errors) {
      allProducts[index] = {
        ...allProducts[index],
        errors: errors,
      };
      isError = true;
      errorCount = errorCount + 1
    } else {
      allProducts[index] = {
        ...allProducts[index],
        errors: null,
      };
    }
  });

  return {
    allProducts,
    isError,
    errorCount
  };
};

// Prepare Draft Update Post Data
export const prepareDraftUpdatePostData = (draftInventoryData) => {
  let postDataList = [];

  draftInventoryData?.forEach((item) => {
    if (!item.isSelected) return;

    postDataList.push({
      id: item?.id,
      productId: item?.productId,
      productOriginalPrice: Number(item?.productOriginalPrice),
      productSalePrice: Number(item?.productSalePrice),
      availableQuantity: Number(item?.availableQuantity),
      status: "IMPORTED",
    });
  });

  return postDataList;
};
